import React,{Component} from 'react';
import swal from 'sweetalert';
import { translate } from 'react-i18next';
import moment from 'moment';
import { Table } from 'react-bootstrap';
import SvgIcon from 'react-icons-kit';
import {checkmark} from 'react-icons-kit/icomoon/checkmark';
import {ic_local_offer} from 'react-icons-kit/md/ic_local_offer';

import Help from '../../generics/help';
const Config = require('../../../config');

class SelfExclutionList extends Component{
    constructor(props){
        super(props);

        this.getList = this.getList.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.validFields = this.validFields.bind(this);
        this.printSampleLabel = this.printSampleLabel.bind(this);

        this.state = {
            list: [],
            start_date:moment().format('YYYY-MM-DD'),
            end_date:moment().format('YYYY-MM-DD'),
            preview_print:{},
        }
    }

    componentDidMount(){
        fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
        })
        
        this.getList();


    }

    getList(){
        if(this.validFields()){
            this.props.waiting.handleShow('Cargando...');
            fetch(Config.default.apiGateway.URL+'self_exclusion?hf_id='+sessionStorage.getItem('health_facilities_id')+
                '&start_date='+this.state.start_date+'&end_date='+this.state.end_date,{
                method:'GET',
                headers: new Headers({
                    'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                    'Accept'        : 'application/json',
                    'Content-Type'  : 'application/json'
                })
            }).then(res => {
                this.props.waiting.handleClose();
                if(res.ok){
                    return res.json();
                }else{
                    res.text().then((msg)=>
                        swal('Error', msg, 'error')
                    );
                }
            }).then(response => {
                if(response !== undefined){
                    this.setState({list: response});
                }
            })
        }else{
            swal('Error', 'Campos requeridos', 'error');
        }
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    validFields(){
        var valid = true;
        if(this.state.start_date === ""){
            valid = false;
            document.getElementById('start_date').classList.add('error');
        }else{
            document.getElementById('start_date').classList.remove('error');
        }
        if(this.state.end_date === ""){
            valid = false;
            document.getElementById('end_date').classList.add('error');
        }else{
            document.getElementById('end_date').classList.remove('error');
        }

        return valid;
    }

    printSampleLabel(e, id){
		e.preventDefault();

		fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+
			sessionStorage.getItem("health_facilities_id")+'&file_type=label_self_exclusion&extraction_type=',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
			if(res.ok){
			  return res.json();
			}else{
			  res.text().then(function(result) {
				swal('¡Error', result, 'error');
			  });
			}})
		.then(response => {
			if(response.res === 0){
				swal('¡Error!', "No se ha definido ninguna etiqueta para el \"Registro de Muestras\"", 'error');
			}else{
				this.props.waiting.handleShow('Imprimiendo...');

				var obj ={};
				obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
				obj.id = id;
				obj.file_type = "label_self_exclusion";
				obj.nEtiqueta = [0];
				obj.reference_id = this.state.petition_id;

				var print = false;

				if(this.state.preview_print.value !== "NO"){
					print = true;
				}

				var document = this.props.printLabel(obj, print)

				if(document !== undefined){
					this.props.waiting.handleClose();
				}else{
					this.props.waiting.handleClose();
				}
				
			}
		});
	}

    render(){
        const {t} = this.props;
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						Donantes ->
						Autoexclusión
					</h5>
				</div>
                
				<Help 
					{...this.props}
	                menu={"help_donors"} 
                    submenu={"help_self_exclusion"}  />

	            <div className="col-xs-12 form-group">
                    <div className="col-xs-12 form-group">
                        <div className="col-xs-12 col-sm-2">
                            <span className="span-min">Fecha desde</span>
                            <input type="date" name="start_date" id="start_date" value={this.state.start_date}
                                className="form-control" onChange={(e)=>this.handleChange(e)} />
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <span className="span-min">Fecha hasta</span>
                            <input type="date" name="end_date" id="end_date" value={this.state.end_date}
                                className="form-control" onChange={(e)=>this.handleChange(e)} />
                        </div>
                        <div className="col-xs-2" style={{marginTop:18}}>
                            <button className="btn btn-info" onClick={(e)=>this.getList(e)}>Buscar</button>
                            <button className="btn btn-info" style={{marginLeft:8}} onClick={()=>this.props.history.push('autoexclution/new')}>Nuevo</button>
                        </div>
                    </div>
                    <div className="col-xs-12">
                        <Table responsive hover>
                            <thead>
                                <tr>
                                    <th>No. Ofrecimiento</th>
                                    <th>No. Donación</th>
                                    <th>Donador</th>
                                    <th>Fecha Autoexclusión</th>
                                    <th>Usuario</th>
                                    <th>Autoexclusión</th>
                                    <th>Etiqueta</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.list.map((list, i)=>
                                    <tr key={i}>
                                        <td>{list.offer_id}</td>
                                        <td>{list.donation_number}</td>
                                        <td>{list.donor_name}</td>
                                        <td>{moment(list.self_exclusion_date).format('DD/MM/YYYY HH:mm:ss')}</td>
                                        <td>{list.user}</td>
                                        <td>
                                            {list.can_edit &&
                                                <SvgIcon icon={checkmark} size={25} 
                                                    style={list.complete ? {cursor:'pointer'} : 
                                                        {color:'var(--color-partial-data)', cursor:'pointer'}} 
                                                    onClick={()=>this.props.history.push('/autoexclution/edit/'+list.id)}
                                                />   
                                            }
                                        </td>
                                        <td>
                                            <SvgIcon size={25} icon={ic_local_offer}
                                                style={{cursor:'pointer', marginLeft:8}}
                                                onClick={(e)=>this.printSampleLabel(e, list.offer_id)}
                                            />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
                
            </div>
        )
    }
}

export default translate('traslations') (SelfExclutionList);